import {ChangeDetectionStrategy, Component, inject, OnInit, resource, ViewEncapsulation} from "@angular/core";
import {
  CampaignWidgetSingleApiService
} from "../../../../api/campaign-widget-single/campaign-widget-single.api.service";
import {SafePipe} from "safe-pipe";
import {Router, RouterLink} from "@angular/router";
import {NgClass} from "@angular/common";
import {
  MainDonateButtonComponentShort
} from "../../../../common/components/buttons/main-donate-button/main-donate-button.short.component";
import {CampaignRepository} from "../../../../api/campaign/campaign.repository";
import {
  DonationProgressBarAndStateCombiningComponent
} from "../../../campaigns-page/[slug]/component/combining/donation-progress-bar-and-state.combining.component";
import {firstValueFrom} from "rxjs";

@Component({
  standalone: true,
  selector: 'app-active-campaigns-section-component',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `

    <div class="grid grid-cols-12 gap-4 max-w-[1330px] w-full">

      <div class="col-span-12 max-lg:mt-8">
        <div [ngClass]="getClassByTitle()" class="text-5xl font-bold font-tektur text-[#323232] max-lg:text-5xl pb-4"
             i18n>
          {{ title }}
        </div>
        <div class="col-span-8 text-xl font-tektur text-mainColor pb-4" i18n>
          {{ description }}
        </div>
      </div>
      <div class="col-span-12">
        <div class="flex flex-wrap max-lg:gap-16 gap-8 pb-4 justify-start">
          @if (campaigns.value(); as campaigns) {
            @for (campaign of campaigns; track campaign.id) {
              <div class="max-w-[422px] w-full flex flex-col bg-white rounded-xl gap-2">
                <img class="w-full h-[237px] rounded-xl object-cover cursor-pointer"
                     [routerLink]="['/campaigns', campaign.slug]"
                     [src]="'https://api.car4ukraine.com' + campaign?.photo?.formats?.large?.url" alt="Card Image"/>
                <div class="flex flex-col gap-4 justify-between">
                  <div class="flex flex-col justify-between">

                    <div
                      class="bg-white rounded-md flex flex-col items-center max-xl:mt-0 max-xl:ml-0 gap-1">
                      <div class="px-3 text-xl tracking-wide w-full font-tektur font-bold max-xl:line-clamp-3">
                        {{ campaign.title }}
                      </div>
                      <app-donation-progress-bar-and-state-combining
                        [currency]="campaign.getCurrency()"
                        [goalAmount]="campaign.getGoalAmount(false)"
                        [totalRaised]="campaign.getTotalRaised()"
                        [donations]="campaign.getDonations()"/>
                    </div>

                    <!--                    <div class="mt-1 text-gray-500 font-tektur font-bold max-xl:line-clamp-3">-->
                    <!--                      {{ campaign.title }}-->
                    <!--                    </div>-->
                    <div class="px-3 mt-1 text-gray-500 font-tektur line-clamp-3"
                         [innerHTML]="campaign.description | safe: 'html'"></div>
                  </div>
                  <div class="grid grid-cols-1 gap-2 px-3 pb-3">
                    <div>
                      <app-main-donate-button-short [href]="campaign.url + '?hide_donation_meter=true'"
                                                    class="hidden lg:block"
                                                    [eventParams]="{ trackEvent: 'Donate_active_campaigns', section: 'active_campaigns' }"/>
                      <app-main-donate-button-short [href]="['/campaigns', campaign.slug].join('/') + '#donorbox-frame'"
                                                    class="lg:hidden"
                                                    target="_self"
                                                    [useDonorBox]="false"
                                                    [eventParams]="{ trackEvent: 'Donate_active_campaigns', section: 'active_campaigns' }"/>
                    </div>
                    <div>
                      <a
                        [routerLink]="['/campaigns', campaign.slug]"
                        class="min-w-full w-full h-[64px] tracking-widest border-2 border-[#1f2024] justify-center items-center gap-[7px] inline-flex secondary-button">
                        <div
                          class="text-center uppercase text-xl font-medium leading-loose">
                          Learn more
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            }
          }
          @if (campaigns.isLoading()) {
            Loading...
          } @else if (!campaigns.value().length) {
            No active campaigns!
          }
        </div>
      </div>
    </div>
  `,
  imports: [
    SafePipe,
    NgClass,
    RouterLink,
    MainDonateButtonComponentShort,
    DonationProgressBarAndStateCombiningComponent
  ],
  host: {
    class: `w-full p-10 py-36 flex flex-col items-center justify-center max-md:p-16 max-md:px-2.5 max-md:bg-[#EAECED]`
  }
})
export class ActiveCampaignsComponent implements OnInit {

  private readonly campaignRepository = inject(CampaignRepository);
  private readonly campaignWidgetSingleApiService = inject(CampaignWidgetSingleApiService);
  protected readonly campaigns = resource({
    request: () => ({}),
    defaultValue: [],
    loader: () => {
      const request$ = this.campaignRepository.findAll();
      const result = firstValueFrom(request$);
      return result;
    },
  });
  protected readonly route = inject(Router);
  public title: string = 'Active Campaigns';
  public description: string = 'It’s hard to help everyone but we do our best. Join a campaign you like and help us help these warriors.';

  public ngOnInit() {
    if (this.route.url === '/') {
      this.title = 'Active Campaigns';
    } else if (this.route.url === '/campaigns') {
      this.title = 'Campaigns'
      this.description = 'It’s hard to help everyone but we do our best. Join a campaign you like and help us help these warriors.'
    }
    this.campaignWidgetSingleApiService.documents().subscribe({
      next: (documents) => {
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  public getClassByTitle() {
    if (this.title === 'Campaigns') {
      return 'text-8xl';
    }
    return '';
  }
}
